// app/auth/login/ChooseRolePanel.js
import React from 'react';
import { Button, Typography } from '@material-ui/core';

const toButtonLabel = (role) => String(role ?? '').trim().replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export default function ChooseRolePanel({ roles = [], onSelect, onRefresh, disabled }) {
    return (
        <div className="w-full mt-12">
            <Typography variant="subtitle1" className="w-full text-center mb-8 opacity-80 text-xs">Choose a role to continue</Typography>

            {Array.isArray(roles) && roles.length > 0 ? (
                <div className="flex flex-wrap gap-8">
                    {roles.map((r) => (
                        <Button className="flex-1" key={String(r)} variant="contained" disabled={!!disabled} onClick={() => (onSelect ? onSelect(r) : console.log('[chooseRole] select:', r))}>
                            {toButtonLabel(r)}
                        </Button>
                    ))}
                </div>
            ) : (
                <div className="flex items-center gap-12">
                    <Typography variant="body2" className="opacity-60 text-xs">No roles available yet.</Typography>
                    <Button variant="text" disabled={!!disabled} onClick={() => (onRefresh ? onRefresh() : console.log('[chooseRole] refresh'))}>Refresh</Button>
                </div>
            )}
        </div>
    );
}
